import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaModal from './VaModal.vue'

export default withConfigTransport(VaModal)
